<h2 mat-dialog-title class="groups-title">Gruppenzugehörigkeit verwalten</h2>
<div class="groups-title-divider"></div>

<mat-dialog-content class="groups-content">
  <!-- Group selector -->
  <mat-form-field appearance="outline" class="groups-select">
    <mat-label>Gruppe auswählen</mat-label>
    <mat-select
      [(value)]="selectedGroupId"
      (selectionChange)="onGroupSelected()"
      placeholder="Bitte wählen"
      [disabled]="isLoadingUsers">
      <mat-option *ngFor="let group of availableGroups" [value]="group.id">
        {{ group.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Loading users -->
  <div *ngIf="isLoadingUsers" class="groups-loading">
    <mat-icon class="groups-spinner">hourglass_empty</mat-icon>
    <span>Lade Benutzer...</span>
  </div>

  <!-- No group selected -->
  <p *ngIf="!isLoadingUsers && selectedGroupId == null" class="groups-empty">
    Bitte eine Gruppe auswählen.
  </p>

  <!-- No members -->
  <p *ngIf="!isLoadingUsers && selectedGroupId != null && memberEntries.length === 0" class="groups-empty">
    Keine Mitglieder in dieser Gruppe.
  </p>

  <!-- Member list (only users in the group) -->
  <div class="groups-list" *ngIf="!isLoadingUsers && selectedGroupId != null && memberEntries.length > 0">
    <mat-card class="user-card" *ngFor="let entry of memberEntries">
      <div class="user-info">
        <mat-icon class="user-icon">person</mat-icon>
        <div class="user-details">
          <div class="user-name">{{ entry.displayName }}</div>
          <div class="user-email">{{ entry.user.email }}</div>
        </div>
      </div>
      <div class="user-actions">
        <button
          mat-icon-button
          color="warn"
          [disabled]="isUserProcessing(entry.user.uid)"
          (click)="onRemoveUser(entry)"
          aria-label="Entfernen"
          matTooltip="Aus Gruppe entfernen">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </mat-card>
  </div>

  <!-- Add user section -->
  <div class="add-user-section" *ngIf="!isLoadingUsers && selectedGroupId != null">
    <div class="add-user-divider"></div>
    <mat-form-field appearance="outline" class="add-user-field">
      <mat-label>Benutzer suchen und hinzufügen</mat-label>
      <input
        matInput
        [matAutocomplete]="autoUser"
        [formControl]="addUserControl"
        placeholder="Name oder E-Mail eingeben">
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete
        #autoUser="matAutocomplete"
        (optionSelected)="onAddUser($event.option.value)">
        <mat-option *ngFor="let user of filteredUsers | async" [value]="user">
          {{ getUserDisplayName(user) }}
          <span class="autocomplete-email"> – {{ user.email }}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</mat-dialog-content>

<div class="groups-bottom-divider"></div>

<mat-dialog-actions class="groups-dialog-actions">
  <button
    mat-stroked-button
    class="groups-btn close-btn"
    (click)="onClose()">
    <mat-icon>close</mat-icon>
    <span>Schließen</span>
  </button>
</mat-dialog-actions>
